export const SubscriptionWarningNonAdmin = ({ subscription = {} }) => {
  let showWarning = subscription?.isTrialActive;
  if (subscription?.subscriptionEndDate?.toDate) {
    //check if subscription will end in 14 days
    showWarning =
      subscription?.subscriptionEndDate?.toDate() - new Date() <
      14 * 24 * 60 * 60 * 1000;
  }

  if (!showWarning) return null;

  return (
    <div
      className="subscription-warning-banner"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1050,
        padding: '12px 20px',
        minHeight: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <span style={{ color: '#856404', fontSize: '14px' }}>
        Your Plan is about to Expire. Please contact your Administrator.
      </span>
    </div>
  );
};
